// framework
import React, { useCallback } from "react";
// constants
import { IMAGES, MESSAGES } from "constants/constants";
// styles
import styles from "./VideoPlayingView.module.scss";
//components
import Button from "components/Shared/Button/Button"
import Player from "components/Shared/Player/Player";

export default function VideoPlayingView({ player, room }) {

    const handleSkip = useCallback(() => {
        room?.send(MESSAGES.TO_SERVER.SKIP_VIDEO, {});
    }, [room]);

    return (
        <div className={styles.waitingView}>
            {/*<img src={IMAGES.CLIENT.mdmdLogo} alt="Million Dollar Money Drop" className={styles.logo} />*/}
            <Player className={styles.player} player={player} room={room} />
            <div className={styles.buttons}>
                <Button className={styles.button} onClick={handleSkip} >
                    Skip Video
                </Button>
            </div>
        </div>
    );
}